import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useGetApi } from "src/hooks";
import { useDispatch } from "src/redux/hooks";
import { setBridgeLogUsers } from "src/redux/slices/generatorSlice";
import { getYachtId } from "src/utils";

import { mapUsers } from "../utils/mapUsers";
/**
 * Custom hook to fetch and manage bridge users for a logbook.
 *
 * @returns void
 */
export const useGetBridgeUsers = () => {
  const dispatch = useDispatch();
  const yachtid = getYachtId();
  const { logbookId } = useParams();
  const { data: users, refetch } = useGetApi<{ list: any[] }>({
    request: "get-bridge-users",
    body: {
      params: {
        yachtid,
        lbid: logbookId,
      },
    },
    fetchOnInit: false,
  });
  const parsedUsers = useMemo(
    () =>
      users?.list && users.list.length > 0
        ? mapUsers(users.list, "", "role firstname surname")
        : [],
    [users],
  );
  useEffect(() => {
    if (window.navigator.onLine) {
      void refetch();
    }
  }, [refetch]);

  useEffect(() => {
    dispatch(setBridgeLogUsers(parsedUsers));
  }, [dispatch, parsedUsers]);
};
